// src/main.js (Vue)
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './index.css'
import './styles/tailwind.css'
import { setToken } from './api/client'

const t = localStorage.getItem('ctv_token')
if (t) setToken(t)

createApp(App).use(router).mount('#app')
